import API from ".";

export const flowRatesByBranchEwi = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.periodWithOutDay ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";

    const response = await API.get(`generate/portfolio_delinquency/list_flow_rates_by_ewi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

export const productFlowByEwi = async (filters: any) => {
  try {
    const fromDate = filters.fromDate ?? "";
    const toDate = filters.toDate ?? "";
    const period = filters.periodWithOutDay ?? "";
    const state = filters.state ?? "";
    const territory = filters.territory ?? "";
    const cluster = filters.cluster ?? "";
    const branch = filters.branch ?? "";

    const response = await API.get(`generate/portfolio_delinquency/list_product_flow_rates_by_ewi?from_date=${fromDate}&to_date=${toDate}&group_by=${period}&state_id=${state}&territory_id=${territory}&cluster_id=${cluster}&branch_id=${branch}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


